// extracted by mini-css-extract-plugin
export default {"icon":"PDFDownload_icon__QOdWc","disabled":"PDFDownload_disabled__KLwvn"};